import { useTranslation } from 'react-i18next';

import styles from './PaymentDetails.module.css';
import type { ConfigState } from 'services/store/features/Config/types';
import type { UserState } from 'services/store/features/User/types';

interface Props {
  user: UserState;
  config: ConfigState;
}

export default function Header({
  user, config,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.recap}>
      <p className={styles.bold}>{t('downloadInvoice.detailTransaction')}</p>
      <div className={styles.recapSection}>
        <p>{t('invoicingForm.administrationFees')}</p>
        <p>{`${Number.parseFloat(config.amountRegistration).toLocaleString(undefined, { minimumFractionDigits: 2 })} €`}</p>
      </div>
      <hr />
      <div className={styles.recapSection}>
        <p>{t('invoicingForm.noVAT')}</p>
        <p>{`${Number.parseFloat(config.amountRegistration).toLocaleString(undefined, { minimumFractionDigits: 2 })} €`}</p>
      </div>
      <div className={styles.recapSection}>
        <p>{t('invoicingForm.taxes')}</p>
        <p>{`${(Number.parseFloat(config.amountRegistration) * (user.vatRate / 100)).toLocaleString(undefined, { minimumFractionDigits: 2 })} €`}</p>
      </div>
      <hr />
      <div className={styles.recapSection}>
        <p className={styles.bold}>{t('invoicingForm.net')}</p>
        <p>{`${(Number.parseFloat(config.amountRegistration) + Number.parseFloat(config.amountRegistration) * (user.vatRate / 100)).toLocaleString(undefined, { minimumFractionDigits: 2 })} €`}</p>
      </div>
    </div>
  );
}
